// Реестр «отложенных» (debounce) записей количества из карточек каталога.
// Позволяет дождаться, пока все pending-изменения количества доедут до бэка,
// прежде чем перейти на страницу опций (иначе grouped отдаст устаревший набор).

type FlushFn = () => Promise<unknown>;

const flushes = new Set<FlushFn>();

export const registerQuantityFlush = (fn: FlushFn): (() => void) => {
  flushes.add(fn);
  return () => {
    flushes.delete(fn);
  };
};

export const flushQuantities = (): Promise<unknown> =>
  Promise.all([...flushes].map((fn) => fn().catch(() => undefined)));
